export function track(event: string, params?: Record<string, any>) {
  try {
    const w = window as any
    if (!w || typeof w.gtag !== 'function') return

    const consentState = w.Termly?.getCurrentConsentState?.()
    const analyticsAllowed = consentState ? !!(consentState.analytics || consentState.preferences || consentState.performance) : false
    if (!analyticsAllowed) return

    w.gtag('event', event, params || {})
  } catch (_err) {
    // no-op
  }
}

